import { useEffect } from "react";
import { SITE_URL } from "@/lib/site-data";

const SITE = "Planet Air Adventure";
const DEFAULT_DESC =
  "Licensed Bhutan travel house in Paro since 2021. Private Bhutan tour packages, Himalayan treks, tsechu festivals and Drukair & Bhutan Airlines tickets.";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function useJsonLd(id, data) {
  useEffect(() => {
    const scriptId = `jsonld-${id}`;
    let el = document.getElementById(scriptId);
    if (data) {
      if (!el) {
        el = document.createElement("script");
        el.type = "application/ld+json";
        el.id = scriptId;
        document.head.appendChild(el);
      }
      el.textContent = JSON.stringify(data);
    } else if (el) {
      el.remove();
    }
    return () => {
      const s = document.getElementById(scriptId);
      if (s) s.remove();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, JSON.stringify(data)]);
}

export default function useSEO({ title, description, path = "", image, noindex = false } = {}) {
  useEffect(() => {
    const fullTitle = title
      ? `${title} — ${SITE}`
      : `${SITE} — Bhutan Tour Packages & Air Tickets from Paro`;
    const desc = description || DEFAULT_DESC;
    // Always the production domain, so preview/staging URLs never claim to be the original
    const url = `${SITE_URL}${path || "/"}`;

    document.title = fullTitle;
    setMeta("name", "description", desc);
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:url", url);
    setMeta("name", "twitter:title", fullTitle);
    setMeta("name", "twitter:description", desc);
    setMeta("name", "robots", noindex ? "noindex, follow" : "index, follow, max-image-preview:large");
    if (image) {
      setMeta("property", "og:image", image);
      setMeta("name", "twitter:image", image);
    }

    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", url);
  }, [title, description, path, image, noindex]);
}
